import http from "../../../../../core/utils/apis/skillApi";

const TrainingRequestsOverviewService = {
  getRequests: () => http.get("/trainings-reports/requests"),
  getRequestStats: () => http.get("/trainings-reports/requests-stats"),
  getRequestsByDepartment: () => http.get("/trainings-reports/requests-by-department"),
  getRequestsTrendOverTime: () => http.get("/trainings-reports/requests-trend"),
};

export default TrainingRequestsOverviewService;
